"use strict";function rotateView$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.rotateView$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.screen.rotateView";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.0.0"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.0.0"},_a)),exports.rotateView$=rotateView$,exports.default=rotateView$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/screen/rotateView.js
// module id = 1079
// module chunks = 106